import { RouteType } from "types/RouteType";
import MaterialInventoryRoute from "../inventory/MaterialInventory/MaterialInventory.Route";

// Note: This module now focuses on raw materials inventory and field delivery tracking
// Removed precast-specific modules: HardwareFloorTracker, HardwareOrders, HardwareOverview,
// PanelYardManagement, and IFCTracker

const inventoryAndFieldRoutesList: RouteType[] = [
  MaterialInventoryRoute,
];

export default inventoryAndFieldRoutesList;
